export default "__VITE_ASSET__BLbgQRK$__"